import React from 'react';

import { Box, Skeleton } from '@mui/material';

import { LISTING_ROWS_PER_PAGE } from '@klokhuis/constants/Listings';
import { useListingSelectors } from '@klokhuis/modules/Properties/context/hooks/useListingSelectors';
import { ListingsContext } from '@klokhuis/modules/Properties/context/ListingsContext';
import { useFilterStateDispatcher } from '@klokhuis/modules/Properties/hooks/useFilterStateDispatcher';

import styles from './Pagination.module.css';

import { PropertyPagination } from '@klokhuis/modules/Properties/components/PropertyPagination/PropertyPagination';

const computePageCount = (totalListings: number) => {
  return Math.ceil(totalListings / LISTING_ROWS_PER_PAGE);
};

const PaginationInternal = () => {
  const isLoading = useListingSelectors().isLoading();
  const { listingsState } = ListingsContext.useContext();
  const total = useListingSelectors().getListingCount();
  const { filterStateDispatcher } = useFilterStateDispatcher();

  const totalPageCount = computePageCount(total || 0);

  const handlePaginationChange = React.useCallback(
    (pageNo: number) => {
      window.scrollTo(0, 0);
      filterStateDispatcher({
        ...listingsState.filterResult.filters,
        pageNo,
      });
    },
    [filterStateDispatcher, listingsState.filterResult.filters],
  );

  if (isLoading) {
    return (
      <Box className={styles.loadingContainer}>
        <Skeleton variant="rectangular" width={320} height={40} />
      </Box>
    );
  }

  if (totalPageCount <= 1) return null;

  return (
    <PropertyPagination
      count={totalPageCount}
      page={listingsState.filterResult.filters.pageNo || 1}
      onChange={(_event, page) => handlePaginationChange(page)}
    />
  );
};

const Pagination = React.memo(PaginationInternal);

export default Pagination;
